<template>
	<vxe-modal v-model="realTimeStatisFlag" title="实时报表" :destroy-on-close="true"
					fullscreen remember :esc-closable="true" :mask="false":lock-view="false" show-zoom resize>
		<a-layout  style="padding: 0;">
			<a-layout-sider   width="240" theme="light" class="mySider">
				<a-directory-tree multiple default-expand-all @select="onSelect"  :defaultSelectedKeys="checkedMonitor">
					<a-tree-node v-for="(item,index) in parentList" :key="item.value" :title="item.name" style="color: white;">
						<a-tree-node  v-for="(subItem,subIndex) in getSubTreeLeafNodeByParent(item.name,item.value)"
														:key="subItem.meterId"  :title="subItem.monitorName" is-leaf />
					</a-tree-node>
				</a-directory-tree>
			</a-layout-sider>
			<a-layout-content style="background-color: white;padding: 0.625rem;">
				<div class="actDiv">
					<label style="font-size: 0.8rem;">时间区间：</label>
					<a-date-picker v-model="dateStart" style="margin-right: 0.5rem;width: 6rem;"
											show-time format="YYYY-MM-DD HH:mm:ss" :disabled="true"/>
					<label>至</label>
					<a-date-picker   v-model="dateEnd"  style="margin-left: 0.5rem;width: 6rem;"
									show-time format="YYYY-MM-DD HH:mm:ss" :disabled="true"/>
					<label style="font-size: 0.8rem;margin-left: 0.625rem;" v-show="false">水量区间：</label>
					<a-input-number style="width:5.5rem;margin-right: 0.3125rem;font-size: 0.8rem;"
										v-model="usedBegin" step="0.1" size="small" :min="0.1" v-show="false"/>
					<label style="font-size: 0.8rem;"  v-show="false">-</label>
					<a-input-number style="width:5.5rem;margin-left: 0.3125rem;font-size: 0.8rem;" 
									v-model="usedEnd"  step="0.1" size="small" :min="0.1"  v-show="false"/>
					<a-button size="small"   icon="search" @click="doQuery" style="margin: 0 0.5rem;" :loading="loading">查询</a-button>
					<a-button  size="small"   @click="doExport"  icon="cloud-download">导出</a-button>
				</div>
				<a-tabs type="card">
					<a-tab-pane key="1" tab="抄收报表">
						<a-table  size="small" :columns="columns" :data-source="statisList" bordered :loading="loading"
										rowKey="id" :pagination="false" :scroll="{y:500}" :hideOnSinglePage="false">
							<span slot="theAction" slot-scope="text, record">
							</span>
						</a-table>
					</a-tab-pane>
					<a-tab-pane key="2" tab="曲线分析图" :forceRender="true">
						<ve-line :data="statisData"  :settings="chartSettings" :extend="chartExtend" 
						:legend="{ bottom: '0' }" :title="{text:statisTitle,x:'center',y:'top'}"
						 judge-width  height="500px"/>
					</a-tab-pane>
				</a-tabs>
			</a-layout-content>
		</a-layout>
	</vxe-modal>
</template>

<script>
	const columns = [
		{
			title: '给水号',
			dataIndex: 'apId',
			width:120,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '表地址',
			dataIndex: 'meterAddr',
			width:140,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '监控点名称',
			dataIndex: 'monitorName',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '口径',
			dataIndex: 'caliber',
			width:90,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '表读数',
			dataIndex: 'readData',
			width:110,
			className:'v-cell',
			align:'center',
		},
		{
			title: '间隔流量',
			dataIndex: 'intervalFlow',
			width:100,
			className:'v-cell',
			align:'center',
		},
		{
			title: '上传时间',
			dataIndex: 'readTime',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		// {
		//     title: '操作',
		//     key: 'pId',
		//     scopedSlots: { customRender: 'theAction' },
		// 	width:60,
		// 	className:'v-cell',
		// 	align:'center',
		//   },
	];
	export default {
		data(){
			return {
				columns,
				usedBegin:null,
				usedEnd:null,
				dateStart:null,
				dateEnd:null,
				dataList:[],
				realTimeStatisFlag:false,
				checkedMonitor:[],
				statisList:[],
				loading:false,
				statisData:{},
				chartExtend:{
					series:{
						smooth:true,
						type:'line',
					},
				},
				chartSettings:{
					area: false, 
					yAxisName: ['间隔流量', '压力'],
					axisSite: { right: ['pressure'] },
					labelMap: {
						intervalFlow: '流量',
						pressure: '压力',
					  },
				},
				parentList:[],
			}
		},
		methods:{
			getSubTreeLeafNodeByParent(parentName,parentKey){
				let temp = [];
				if(parentKey == 0){
					temp = this.Config.deepClone(this.dataList);
				}else{
					let a = parentName.split("(");
					for (var i = 0; i < this.dataList.length; i++) {
						let item =  this.dataList[i];
						if(item.groupName == a[0]){
							temp.push(item);
						}
					}
				}
				return temp;
			},
			createParentList(){
				let titleList = ["监控点"];
				this.dataList.forEach((item)=>{
					if(titleList.indexOf(item.groupName) ==-1){
						titleList.push(item.groupName);
					}
				});
				for (var i = 0; i < titleList.length; i++) {
					let name = titleList[i];
					let array = this.getSubTreeLeafNodeByParent(name,i);
					let title = name+"("+array.length+")";
					let item = {name:title,value:i};
					this.parentList.push(item);
				}
			},
			doQuery(){
				if(this.usedBegin>this.usedEnd){
					this.$message.error("水量区间有误,请重新选择");
					return;
				}
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_REAL_TIME_STATIS_URL);
				let param = {
					meterId:this.checkedMonitor[0],
					beginTime:this.dateStart,
					endTime:this.dateEnd,
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.filterResult(result);
						this.drawEcharts();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			filterResult(list){
				this.statisList = [];
				if(this.usedBegin == null || this.usedEnd == null){
					this.statisList = list;
				}else{
					for(var i=0;i<list.length;i++){
						let item = list[i];
						if(item.intervalFlow>=this.usedBegin && item.intervalFlow<=this.usedEnd){
							this.statisList.push(item);
						}
					}
				}
			},
			showView(meterIdList){
				this.checkedMonitor = meterIdList;
				if(this.realTimeStatisFlag == false){
					this.realTimeStatisFlag = true;
				}
				this.dateStart = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');;
				this.dateEnd = this.$moment().format('YYYY-MM-DD HH:mm:ss');
				this.doQuery();
			},
			getMeterMonitorList4Map(){
				this.dateEnd = this.$moment().format('YYYY-MM-DD HH:mm:ss');
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_MAP_INFO_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			getShowTime(realTime){
				if(realTime.length){
					let a = realTime.split(" ");
					let b = a[1].split(".")[0];
					return b;
				}else{
					return "";
				}
			},
			drawEcharts(){
				var rows = [];
				for(var i =0 ;i<this.statisList.length;i++){
					var item = this.statisList[i];
					var obj = {
						"readTime":this.getShowTime(item.readTime),
						"intervalFlow":item.intervalFlow,
						"pressure":item.pressure
					}
					rows.push(obj);
				}
				var statisData = {
					columns: ['readTime','intervalFlow', 'pressure'],
					rows:rows.reverse(),
				}
				this.statisData = statisData;
			},
			doExport(){
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_REAL_TIME_STATIS_EXPORT_URL);
				let param = {
					monitorName:this.monitorName,
					meterId:this.checkedMonitor[0],
					beginTime:this.dateStart,
					endTime:this.dateEnd,
				};
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = this.monitorName+'-实时报表'+'.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			onSelect(keys, event){
				this.showView(keys);
			},
			getTheCheckMonitor(){
				var result = null;
				let checkedMeter = this.checkedMonitor[0];
				for(var i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(checkedMeter == item.meterId){
						result = item;
						break;
					}
				}
				return  result;
			},
		},
		created() {
			this.getMeterMonitorList4Map();
		},
		computed:{
			myTitle:function(){
				let a = this.dataList.length;
				return "监控表("+a+")";
			},
			monitorName:function(){
				let item = this.getTheCheckMonitor();
				if(item == null){
					return "";
				}else{
					return item.monitorName;
				}
			},
			statisTitle:function(){
				return "间隔流量曲线("+this.monitorName+")";
			},
		},
	}
</script>

<style>
</style>
